export default {"src":"/_next/static/media/iso_27001_01.c2594eb6.svg","height":595,"width":1328,"blurWidth":0,"blurHeight":0};